import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux';
import { AnimationWrapper } from './views/animate';
import { Phone } from './views/Phone';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<Phone />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Phone)
	.setHudVisible(true)
	.setTransitionTime(400)
	.build();

export default Layout;
